/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { api } from "../api";

const Especie = {
  CACHORRO: 'CACHORRO',
  GATO: 'GATO'
} as const;

const Genero = {
  MACHO: 'MACHO',
  FEMEA: 'FEMEA'
} as const;

type EspecieType = typeof Especie[keyof typeof Especie];
type GeneroType = typeof Genero[keyof typeof Genero];

export type PetData = {
  id?: string;
  nome: string;
  especie: EspecieType;
  genero: GeneroType;
  observacoes?: string;
  obito?: string;
  idade?: string;
}

type PetCreateData = Omit<PetData, 'id'>

export class PetsService {
  async getPets(): Promise<PetData[]>{
    try {
      const response = await api.get('/pet')
      
      return response.data
    } catch (error: any) {
      console.log(error.response.data);
      
      throw {message: error.response?.data.error || 'Erro ao buscar pets'}
    }
  }
  
  async createPet(data: PetCreateData): Promise<PetData>{
    try {
      const response = await api.post('/pet', data)
      return response.data
    } catch (error: any) {
      throw {message: error.response?.data.error || 'Erro ao criar pet'}
    }
  }
  
  async updatePet(id:string, data: PetData): Promise<PetData>{
    try {
      const response = await api.patch(`/pet/${id}`, data)
      return response.data
    } catch (error: any) {
      throw {message: error.response?.data.error || 'Erro ao atualizar pet'}
    }
  }
}